import { useEffect, useCallback, useState } from "react";
import { createSocket } from "../../../config/socketFactory.js";

export const useSocket = (serverPath) => {
  const [online, setonline] = useState(false);

  const [socket, setsocket] = useState(null);

  const conectarSocket = useCallback(
    (paramsToken) => {
      const token = paramsToken || localStorage.getItem("token");

      const socketTemp = createSocket(serverPath, {
        autoConnect: true,
        forceNew: true,
        transports: ["websocket"],
        query: {
          token: token,
          platform: "web",
        },
      });

      setsocket(socketTemp);
    },
    [serverPath],
  );

  const desconectarSocket = useCallback(() => {
    socket?.disconnect();
  }, [socket]);

  useEffect(() => {
    socket?.on("disconnect", () => {
      setonline(false);
    });
  }, [socket]);
  useEffect(() => {
    setonline(socket?.connected);
    socket?.on("connect", () => {
      setonline(true);
    });
  }, [socket]);
  return { socket, online, conectarSocket, desconectarSocket };
};
